export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    title: '#',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 90,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: 'SKU',
    field: 'amzSkuNo',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'skuInfo' },
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'amzFlipOrderSkuStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_estimatedSales') || '补货基数',
    field: 'estimatedSales',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_estimatedFlipQuantity') || '预计翻单数量',
    field: 'estimatedFlipQuantity',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_confirmedSales') || '确认补货基数',
    field: 'confirmedSales',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_actualFlipQuantity') || '实际翻单数量',
    field: 'actualFlipQuantity',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_earliestDeliveryDate') || '期望最早交货日期',
    field: 'earliestDeliveryDate',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyInv') || '国内库存',
    field: 'ftyInv',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('table_label_ftyInvDaysAvailableLocal') || '国内库存可售天数',
    field: 'ftyInvDaysAvailableLocal',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amzMarketName') || '市场',
    field: 'amzMarketName',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'amzMarketName' },
  },
  {
    title: that.$l('table_label_dailySales') || '日销',
    field: 'dailySales',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fbaInv') || 'FBA库存',
    field: 'fbaInv',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyInvDaysAvailable') || 'FBA可售天数',
    field: 'ftyInvDaysAvailable',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fbaSafetyStockDays') || 'FBA安全库存天数',
    field: 'fbaSafetyStockDays',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
]
